<template>
    <div class="input-group">
        <input
            :aria-label="label"
            class="form-control input-monospace"
            :class="`input-${size}`"
            data-autoselect
            readonly
            :type="inputType"
            :value="textToCopy"
        >
        <div class="input-group-btn">
            <button
                class="btn btn-primary"
                :class="`btn-${size}`"
                type="button"
                v-clipboard:copy="textToCopy"
                v-clipboard:success="copied"
            >
                {{ copyButtonText }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CopyToClipboard",

    props: {
        label: {
            default: '',
            required: false,
            type: String,
        },
        size: {
            default: 'md',
            required: false,
            type: String,
            validator: function (value) {
                // The value must match one of these strings
                return ['xs', 'sm', 'md', 'lg'].indexOf(value) !== -1
            }
        },
        textToCopy: {
            required: true,
            type: String,
        },
        copyButtonText: {
            required: false,
            type: String,
            default: 'Copy!'
        },
        hideTextBox: {
            required: false,
            type: Boolean,
            default: false
        }
    },

    computed:{
        inputType(){
            return this.hideTextBox ? "hidden" : "text";
        }
    },

    methods: {
        copied() {
            alert('copied');
            this.$emit(`copied`);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/CopyToClipboard.vue